'use client';

import { ReactNode, useEffect } from 'react';
import { initializeClientTracking, EVENTS_TRACKING_URL } from '@services/tracking';

/** Props */
interface TrackingProviderProps {
  children: ReactNode;
}

/**
 * @description Context provider for tracking events.
 * Initializes the tracking service on mount and provides a context for children components.
 * Use the `trackEvent` function from the tracking service to track user interactions on the client side.
 *
 * - `children`: ReactNode - the child components to be wrapped by this provider.
 *
 * @example
 * // enable debug mode in development
 * initializeClientTracking('/api/tracking', {
 *   debug: process.env.NODE_ENV !== 'production',
 * });
 */
export const EventsTrackingProvider = ({ children }: TrackingProviderProps) => {
  useEffect(() => {
    initializeClientTracking(EVENTS_TRACKING_URL, {
      debug: process.env.NODE_ENV !== 'production',
    });
  }, []);

  return <>{children}</>;
};
